export default __webpack_public_path__ + "static/media/app_preview_1.0b123e7f.svg";